module.exports = __webpack_public_path__ + "b85b54b7cdc8d43734e0104c1e9e9c81.pdf";